import { createSlice, PayloadAction, Dispatch } from '@reduxjs/toolkit';
import { CancelToken } from 'axios';

import { PermissionsState } from 'src/interface/user/group.interface';
import { Http } from 'src/utils/http';

const initialState: PermissionsState = {
  permissionGrants: []
};

const permissionsSlice = createSlice({
  name: 'permissions',
  initialState,
  reducers: {
    setPermissions(state, action: PayloadAction<Partial<PermissionsState>>) {
      Object.assign(state, action.payload);
    }
  }
});

export const { setPermissions } = permissionsSlice.actions;

export default permissionsSlice.reducer;

export const getPermissionsAsync = () => {
  return async (dispatch: Dispatch) => {
    const result: any = await apiGetPermissionsByUser();
    const permissions = result?.content?.permissions.map(d => d.permissionGrant);
    if (result?.success) {
      dispatch(
        setPermissions({
          permissionGrants: permissions
        })
      );
    }
    return permissions;
  };
};


export async function apiGetPermissionsByUser() {
  // const response = await Http.Post('/api/ManageGroup/GetPermissionsByUser', null, {
  //   cancelToken: cancelToken
  // });
  return [];
}